import { Injectable } from '@angular/core';

@Injectable()
export class SanitizerService {

    public sanitizeFromInternalField(obj) {
        // restituisce un oggetto privo dei campi di valutazione interni, che iniziano per '_' (underscore)
        if (obj instanceof Array) {
            const ar = [];
            obj.forEach((el, idx) => {
                ar.push(this.sanitizeFromInternalField(el));
            });
            return ar;
        } else {
            const dump = {};
            for (const key in obj) {
                if (obj[key] instanceof Array) {
                    const arr = [];
                    obj[key].forEach((el, idx) => {
                        arr.push(this.sanitizeFromInternalField(el));
                    });
                    dump[key] = arr;
                } else {
                    if (key.charAt(0) !== '_') {
                        dump[key] = obj[key];
                    }
                }
            }
            return dump;
        }
    }

    public sanitizeFromNull(obj) {
        // restituisce un oggetto privo dei campi null
        if (obj instanceof Array) {
            const ar = [];
            obj.forEach((el, idx) => {
                ar.push(this.sanitizeFromNull(el));
            });
            return ar;
        } else {
            const dump = {};
            for (const key in obj) {
                if (obj[key] instanceof Array) {
                    const arr = [];
                    obj[key].forEach((el, idx) => {
                        arr.push(this.sanitizeFromNull(el));
                    });
                    dump[key] = arr;
                } else {
                    if (obj[key] != null) {
                        dump[key] = obj[key];
                    }
                }
            }
            return dump;
        }
    }
}
